export default __webpack_public_path__ + "static/cNxlgNzq-400f4761982f12b7629f2099d50344ad.svg";